<div   class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
     <!-- Option màu nền cho frame -->
     <app-background-image-config [hasConfigGroup]="true" [configFieldName]="'block-footer'"
     [elementChoosing]="blockChoosing"
     [config]="config"
     [class]="class"
     [backgroundClass]="class['block-footer']"
     [backgroundConfig]="config['block-footer']"
     [id_object]="blockChoosing._id"
     [isBlock]="true"
     [device]="device"
   >
   </app-background-image-config>
   <div class="mr-2 mb-4 mt-4 view-more" style="
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 7px;
    " *ngIf="config['block-footer'].option_background == 'color'">
      <p class="discover_text" (click)="openViewAll(stylesField[2])"
        style="cursor: pointer; text-align: left; margin: 0">
        {{'mo_rong' | translate}} &#8594;
      </p>
    </div>
    </div>
  </ng-container>
  
  
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <div style="margin-top: 10px;"></div>
    <ul nz-menu nzMode="inline" >
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="blockChoosing" [isBlock]="true"></app-hide-show-config>

          <!-- Option màu nền cho frame -->
          <app-background-image-config [hasConfigGroup]="true" [configFieldName]="'block-footer'"
            [elementChoosing]="blockChoosing"
            [config]="config"
            [class]="class"
            [backgroundClass]="class['block-footer']"
            [backgroundConfig]="config['block-footer']"
            [id_object]="blockChoosing._id"
            [isBlock]="true"
            [device]="device"
          >
          </app-background-image-config>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
            <p class="discover_text" (click)="openViewAll(stylesField[2])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>
        </div>
      </li>
      <!-- Cấu hình filter -->
      <li *ngIf="config['block-footer']?.option_background == 'image'" nz-submenu nzTitle="{{'anh_sang_va_tuong_phan'| translate}}"
      [(nzOpen)]="openMenu.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-brightness-contrast-config [elementChoosing]="blockChoosing"  [device]="device" [class]="class" [config]="config"
          [filterConfig]="config['filter']" [opacityClass]="class['block-footer__boundary']" [staticdata]="staticdata"
          [id_object]="blockChoosing._id" [configType]="'background-image'" [isBlock]="true">
        </app-brightness-contrast-config>
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMenu.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config
          [elementChoosing]="blockChoosing"
          [device]="device"
          [class]="class"
          [borderClass]="class['block-footer']"
          [id_object]="blockChoosing._id"
          [isBlock]="true"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right;">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
     <!-- Canh lề -->
     <li nz-submenu nzTitle="{{'canh_le' | translate}}" [(nzOpen)]="openMenu.menu4"
     (nzOpenChange)="openHandler('menu4')">
     <app-padding-config
       [objectChoosing]="blockChoosing"
       [device]="device"
       [class]="class"
       [classPadding]="class['block-footer']"
       [paddingConfigs]="[
         { type: 'top' },
         { type: 'bottom' },
         { type: 'left' },
         { type: 'right' }
       ]"  [isBlock]="true">
     </app-padding-config>
     </li>
      <!-- Cấu hình hiệu ứng -->
      <li
        nz-submenu
        nzTitle="{{'hieu_ung' | translate}}"
        [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')"
      >
        <app-choose-animations-config
          [elementChoosing]="blockChoosing"
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="blockChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['block-footer']"
          [effect_hover]="effect_hover"
          [customize]="customize"
           [isBlock]="true"
          [effectFileUsing]="'block-blank'"
        >
        </app-choose-animations-config>
        <!-- Cấu hình đổ bóng -->
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
      [elementChoosing]="blockChoosing"
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['block-footer']"
        [id_object]="blockChoosing._id"
        [isBlock]="true"
      >
      </app-borders-radius-config>
    </div>

     <!-- Cấu hình chi tiết hiệu ứng -->
     <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config
      [elementChoosing]="blockChoosing"
        [staticdata]="staticdata"
        [config]="config"
        [id_object]="blockChoosing._id"
        [customize]="customize"
        [device]="device"
         [isBlock]="true"
      >
      </app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 3">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <ng-container *ngIf="config['background-color']?.gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color'].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color']['background']"
            type="button" [disabled]="!config['background-color'].gradient_check"
            [style.background]="config['background-color']['background']" (colorPickerClose)="addGradient($event)" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
          [disabled]="!config['background-color'].gradient_check" [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
          "></button>
      </ng-container>
    </div>
  </div>
</div>
